/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    StornoReasonEnum,
    StornoReasonEnumFromJSON,
    StornoReasonEnumFromJSONTyped,
    StornoReasonEnumToJSON,
} from './StornoReasonEnum';

/**
 * 
 * @export
 * @interface StornoReasonItemDto
 */
export interface StornoReasonItemDto {
    /**
     * Cancellation reason
     * @type {StornoReasonEnum}
     * @memberof StornoReasonItemDto
     */
    reason: StornoReasonEnum | null;
    /**
     * Number of users with this cancellation reason
     * @type {number}
     * @memberof StornoReasonItemDto
     */
    usersCount: number;
    /**
     * Percentage of users with storno reason
     * @type {number}
     * @memberof StornoReasonItemDto
     */
    percentage: number;
}

export function StornoReasonItemDtoFromJSON(json: any): StornoReasonItemDto {
    return StornoReasonItemDtoFromJSONTyped(json, false);
}

export function StornoReasonItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StornoReasonItemDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reason': StornoReasonEnumFromJSON(json['reason']),
        'usersCount': json['usersCount'],
        'percentage': json['percentage'],
    };
}

export function StornoReasonItemDtoToJSON(value?: StornoReasonItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reason': StornoReasonEnumToJSON(value.reason),
        'usersCount': value.usersCount,
        'percentage': value.percentage,
    };
}

